import React, { useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
export function SelectBox({ label, onChange, defaultValue, options }) {
    const [value, setValue] = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : 'inherit');
    return (React.createElement(TextField, { select: true, variant: "standard", label: label, value: value, onChange: (ev) => {
            const v = ev.target.value;
            setValue(v);
            onChange(v === null ? null : v);
        } }, options.map((option) => (React.createElement(MenuItem, { key: option.key, value: option.key }, option.label)))));
}
//# sourceMappingURL=SelectBox.js.map